import { CircularProgress } from '@mui/material'
import { Page } from 'Common/Page/Page'

export const Loader = () => {
  return (
    <Page center>
      <CircularProgress />
    </Page>
  )
}
